module.exports = {
  smartFilters: [
    //Streams
    {
      type: "recently_viewed_streams",
      name: "Recently Viewed Streams",
      contentType: "stream",
      description:
        "Streams that were recently viewed by the user so they can pick up from exactly where they dropped off.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },

    //Collections
    {
      type: "my_collections",
      name: "My Collections",
      contentType: "collection",
      description:
        "Collections created by and collaborated with the user so they can find everything they need without leaving the Hub.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },

    //Assets
    {
      type: "most_viewed_assets",
      name: "Popular with your teams",
      contentType: "asset",
      description:
        "This content slaps! Discover the assets that are more popular than casual Friday among your peers.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },
    {
      type: "recently_viewed_assets",
      name: "Continue where you left",
      contentType: "asset",
      description: "Assets that were recently viewed by the user so they can pick up from exactly where they dropped off. ",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
    {
      type: "recently_added_assets",
      name: "Recent additions to Hub",
      contentType: "asset",
      description:
        "Fresh content, served hot. Unlike that coffee you forgot about an hour ago.",
      icon: "/images/hub/smartFilters/recent_additions_to_hub.svg",
    },
    {
      type: "recommended_assets",
      name: "Recommended Assets",
      contentType: "asset",
      description:
        "Paperflite's AI recommends assets based on similar users' reading patterns. It’s like Tinder, but for your content.",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
    {
      type: "recently_updated_assets",
      name: "Recently Updated Assets",
      contentType: "asset",
      description:
        "Check out which assets have been recently edited or changed by your team.",
      icon: "/images/hub/smartFilters/recently_updated_assets.svg",
    },
    {
      type: "frequently_shared_assets",
      name: "Frequently Shared Assets",
      contentType: "asset",
      description:
        "Your Champion Assets! These are the most shared by your team—let’s give them some love!",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
  ],
};
